import type { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TagsService } from '../../../core/services/tags.service';
import type { ApiResponse } from '../../models/response';
import {
  loadTags,
  loadTagsFail,
  loadTagsSuccess,
} from '../actions/tags.actions';

@Injectable()
export class TagsEffect {
  readonly #actions$ = inject(Actions);
  readonly #tagsService = inject(TagsService);

  readonly getTags$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(loadTags),
      switchMap(() => {
        return this.#tagsService.getTags().pipe(
          map((response) => {
            if (response.status) {
              return loadTagsSuccess({ payload: response.data });
            }
            return loadTagsFail({ payload: response });
          }),
          catchError((error: ApiResponse | HttpErrorResponse) =>
            of(loadTagsFail({ payload: error })),
          ),
        );
      }),
    );
  });
}
